import { FileQuestion } from 'lucide-react'
import { type ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { EmptyState } from '@/components/common/EmptyState'
import { buttonVariants } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { useT } from '@/i18n'
import { cn } from '@/lib/utils'

export function NotFoundPage(): ReactNode {
  const t = useT()

  return (
    <Card>
      <EmptyState
        icon={FileQuestion}
        title={t('errors.notFound.title')}
        description={t('errors.notFound.body')}
        action={
          <Link to="/" className={cn(buttonVariants({ variant: 'outline', size: 'sm' }))}>
            {t('errors.notFound.action')}
          </Link>
        }
      />
    </Card>
  )
}
